import request from "@/utils/request"; 

export function createOrder(data) {
  return request({
    url: "/memberApi/order",  //新增
    method: "post",
    data
  });
}

export function getOrderDetails(params) {
  return request({
    url: "/memberApi/order/" + params,
    method: "get",
  });
}


export function orderlist(params) {
  return request({
    url: "/memberApi/order/list",
    method: "get",
    params
  });
}

export function aliPay(params) {
  return request({
    url: "/memberApi/order/aliPay",
    method: "get",
    params
  });
}

export function wxPay(params) {
  return request({
    url: "/memberApi/order/wxPay",
    method: "get",
    params
  });
}

export function checkOrderResult(params) {
  return request({
    url: "/memberApi/order/checkOrderResult",
    method: "get",
    params
  });
}

export function download(params) {
  return request({
    url: "/memberApi/order/download",
    method: "get",
		responseType: 'blob',
    params
  });
}